var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"md6":"","ma-3":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Not Found")])],1),_c('v-card-text',[_c('h3',[_vm._v("\n               Ruh roh! The page you requested could not be found!\n            ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }